<template>
  <div class="footer">
    <div class="back">
      <div class="text">河北鲸诚信用服务有限公司独家运营，旨在为中小企业提供一体化代办服务。</div>
      <div class="phone"><span>联系电话:400-056-5663</span><span>客服微信:鲸诚信</span></div>
      <!-- <div class="filing">
        <div>
          <img src="../assets/images/gs.png" alt="" />
          <span>工商登记信息</span>
        </div>
        <div>
          <img src="../assets/images/gw.png" alt="" />
          <span>网安备案信息</span>
        </div>
      </div> -->
    </div>
    <div class="number">
      <div>©2020-2024 河北鲸诚信用服务有限公司 版权所有</div>
      <!--      <div>备案号:冀ICP备2024056834号-1</div>-->
    </div>
  </div>
</template>
<script>
export default {
  name: "", //
  data() {
    return {};
  },
  components: {},
  props: {},
  methods: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>
<style lang="less" scoped>
/* by wdl */
.footer {
  position: relative;
  background: #116bff;
  color: #fff;
  padding: 10px;

  .back {
    background-size: 100% 100%;
    border: 1px solid #dfb029;
    border-radius: 10px;
    padding: 0px 15px;

    .text {
      font-size: 12px;
      text-indent: 2em;
      margin-top: 10px;
      letter-spacing: 2px;
      line-height: 20px;
    }

    .phone {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 8px 0;
    }

    .filing {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 8px 0;

      div {
        display: flex;
        align-items: center;

        img {
          width: 19px;
          height: 19px;
          margin-right: 4px;
        }
      }
    }
  }

  .number {
    text-align: center;

    div {
      white-space: nowrap;
      margin-top: 5px;
    }
  }
}
</style>
